import { IconProps } from "../../types/utils";

const EditIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 15}
    height={dimension || 15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.83 5.19466L5.33 12.6947C5.15743 12.8635 4.94086 12.9805 4.705 13.0322L2.4925 13.4759C2.29107 13.5157 2.08293 13.5053 1.88648 13.4456C1.69002 13.3859 1.51131 13.2787 1.36612 13.1335C1.22093 12.9883 1.11374 12.8096 1.05403 12.6132C0.994314 12.4167 0.983914 12.2086 1.02375 12.0072L1.46125 9.8134C1.51292 9.57755 1.62987 9.36097 1.79875 9.1884L9.19875 1.78216C9.44036 1.53459 9.72906 1.33785 10.0478 1.20352C10.3666 1.0692 10.7091 1 11.055 1C11.4009 1 11.7434 1.0692 12.0622 1.20352C12.3809 1.33785 12.6696 1.53459 12.9112 1.78216C13.3418 2.25712 13.5735 2.87935 13.5584 3.52026C13.5433 4.16117 13.2825 4.77178 12.83 5.22591V5.19466Z"
      stroke={color || "white"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EditIcon;
